<template>
  <div
    class="rs-next"
    :title="description"
    @click="click"
  >
    <i
      :class="disabled ? `fa-lg far fa-${icon} rs-next--disabled`
        : variant === 'nav' ? `fa-sm far fa-${icon} rs-next--${variant}`
          : `${className}`"
      @mouseover="mouseover"
      @mouseleave="mouseleave"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsNavigationButton',

  props: {

    icon: {
      type: String,
      default: 'arrow-square-right',
    },

    /**
   * Description for button (just like tooltip)
   */
    description: {
      type: String,
      default: 'Next',
    },

    id: [String, Number],

    /**
     * Toggle to disable button
     */
    disabled: {
      type: Boolean,
      default: false,
    },

    /**
     * Color variants:secondary | secondary-light
     *
     */
    variant: {
      type: String,
      default: 'secondary',
      validator: (prop:string) => [
        'secondary',
        'secondary-light',
        'nav',
      ].includes(prop),
    },

  },

  data() {
    return {
      className: `fa-lg far fa-${this.icon} rs-next--${this.variant}`,
    };
  },

  methods: {
    click(event: Event): void {
      if (this.disabled) {
        return;
      }
      this.$emit('click', event);
    },
    mouseover(): void {
      if (this.variant === 'secondary' || this.variant === 'secondary-light') {
        this.className = `fa-lg fas fa-${this.icon} rs-next--${this.variant}`;
      }
    },
    mouseleave(): void {
      if (this.variant === 'secondary' || this.variant === 'secondary-light') {
        this.className = `fa-lg far fa-${this.icon} rs-next--${this.variant}`;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.rs-next {
  position: relative;
  margin: 0;
  padding: 1px;
  line-height: 1.2rem;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: $global-radius;
  cursor: pointer;

  &--secondary{
    font-size: 1.1rem;
    background: transparent;
    color: $secondary-color;
    border-color: $secondary-color-dark;
  }

  &--secondary-light{
    font-size: 1.1rem;
    background: transparent;
    border-color: $dark-gray;
    color: $dark-gray;
  }

  &--nav{
    border-radius: 6px;
    padding: 11px 6px 9px 6px;
    border-color: transparent;
    background-color: $tertiary-muted;
    border-color: $tertiary-muted;
    color: $white;
  }
  &--disabled{
    font-size: 1.1rem;
    border-color: transparent;
    cursor: default !important;
    background-color: rgba($tertiary-gray, 0.5);
    color: #9BA0BB;
    &:hover{
      border-color: transparent;
      background-color: rgba($tertiary-gray, 0.5);
    }
  }
}
</style>
